import * as React from 'react';

function SvgLogIn(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M19.083 2.8H10.75a2.92 2.92 0 00-2.917 2.916v5.417h7.988L13.078 8.39a.833.833 0 011.178-1.178l4.166 4.166a.833.833 0 010 1.178l-4.166 4.167a.833.833 0 01-1.178-1.178L15.82 12.8H7.833v5.416c0 1.67 1.76 2.917 3.334 2.917h7.916A2.92 2.92 0 0022 18.217v-12.5A2.92 2.92 0 0019.083 2.8zm-16.25 8.333a.833.833 0 100 1.667h5v-1.667h-5z" })));
}

export default SvgLogIn;
